import { render, staticRenderFns } from "./VerifyPayments.vue?vue&type=template&id=06ae05da&"
import script from "./VerifyPayments.vue?vue&type=script&lang=js&"
export * from "./VerifyPayments.vue?vue&type=script&lang=js&"
import style0 from "./VerifyPayments.vue?vue&type=style&index=0&id=06ae05da&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports